/* eslint-disable consistent-return, default-case, no-param-reassign */
/*
 *
 * Payment History reducer
 *
 */

import produce from 'immer';

import { RESET_SWITCH_LOAN_STATE, RESET_USER_STATE } from '../../Main/constants';
import {
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_FAILURE,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTION_DETAIL,
  FETCH_TRANSACTION_DETAIL_FAILURE,
  FETCH_TRANSACTION_DETAIL_SUCCESS,
  RESET_PAYMENT_DETAIL_STATE,
  RESET_PAYMENT_HISTORY_STATE,
  SET_GROUPED_TRANSACTIONS,
  UPDATE_SELECTED_TRANSACTION,
} from './constants';

export const initialState = {
  errors: {
    bannerError: false,
    serviceError: {
      transactionDetail: false,
      transactions: false,
    },
  },
  groupedTransactions: [],
  itemsPerPage: 100,
  loading: {
    transactionDetail: true,
    transactions: true,
  },
  openTransaction: {},
  pageToFetch: 1,
  selectedTransaction: '',
  totalPages: -1,
  transactions: [],
};

const paymentHistoryReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case FETCH_TRANSACTIONS: {
      draft.errors.serviceError.transactions = false;
      draft.loading.transactions = draft.pageToFetch !== -1;
      break;
    }
    case FETCH_TRANSACTIONS_FAILURE: {
      const { error } = payload;
      draft.errors.serviceError.transactions = error;
      draft.loading.transactions = false;
      break;
    }
    case FETCH_TRANSACTIONS_SUCCESS: {
      const { page, totalPages, transactions } = payload;
      draft.errors.serviceError.transactions = false;
      draft.pageToFetch = page === totalPages ? -1 : page + 1;
      draft.loading.transactions = false;
      draft.totalPages = totalPages;
      draft.transactions = draft.transactions.concat(transactions);
      break;
    }
    case FETCH_TRANSACTION_DETAIL: {
      const { transactionId } = payload;
      draft.errors.serviceError.transactionDetail = false;
      draft.loading.transactionDetail = true;
      draft.openTransaction = initialState.openTransaction;
      draft.selectedTransaction = transactionId;
      break;
    }
    case FETCH_TRANSACTION_DETAIL_FAILURE: {
      const { error } = payload;
      draft.errors.serviceError.transactionDetail = error;
      draft.loading.transactionDetail = false;
      break;
    }
    case FETCH_TRANSACTION_DETAIL_SUCCESS: {
      const { transaction } = payload;
      draft.loading.transactionDetail = false;
      draft.openTransaction = transaction;
      break;
    }
    case RESET_PAYMENT_DETAIL_STATE: {
      draft.errors.serviceError.transactionDetail = initialState.errors.serviceError.transactionDetail;
      draft.loading.transactionDetail = initialState.loading.transactionDetail;
      draft.openTransaction = initialState.openTransaction;
      draft.selectedTransaction = initialState.selectedTransaction;
      break;
    }
    case RESET_PAYMENT_HISTORY_STATE: {
      draft.errors.serviceError.transactions = initialState.errors.serviceError.transactions;
      draft.itemsPerPage = initialState.itemsPerPage;
      draft.pageToFetch = initialState.pageToFetch;
      draft.totalPages = initialState.totalPages;
      draft.transactions = initialState.transactions;
      break;
    }
    case RESET_SWITCH_LOAN_STATE: {
      return initialState;
    }
    case RESET_USER_STATE: {
      return initialState;
    }
    case SET_GROUPED_TRANSACTIONS: {
      const { groupedTransactions } = payload;
      draft.groupedTransactions = groupedTransactions;
      break;
    }
    case UPDATE_SELECTED_TRANSACTION: {
      const { id } = payload;
      draft.selectedTransaction = id;
      if (!id) {
        draft.errors.serviceError.transactionDetail = false;
        draft.selectedTransaction = '';
        draft.openTransaction = {};
      }
      break;
    }
  }
}, initialState);

export default paymentHistoryReducer;
